export default __webpack_public_path__ + "static/media/blue-blob.5dc1dee8.svg";